import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";

export interface InitiativeListItem {
  id: number;
  name: string;
  status?: string;
  description?: string;
}

interface UseInitiativesPaginatedListArgs {
  corporateId: string | number;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export const useInitiativesPaginatedList = ({
  corporateId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseInitiativesPaginatedListArgs): PaginatedListResult<InitiativeListItem> => {
  const url = corporateId
    ? `${ServicesURL.initiative}/${corporateId}/initiatives?status=ACTIVE`
    : null;

  return usePaginatedList<InitiativeListItem>(url, {
    page,
    pageSize,
    search,
    fieldFilters,
  });
};
